export default {
  complex: {
    avg_price_sqm: 'Durchschnittspreis pro m²',
    min_price: 'Mindestpreis',
    max_price: 'Höchstpreis',
    expected_delivery: 'Voraussichtliche Übergabe',
    construction_start: 'Baubeginn',
    construction_end: 'Bauende',
    sales_start: 'Verkaufsstart',
    distance_to_sea: 'Entfernung zum Meer',
    distance_to_center: 'Entfernung zum Zentrum',
    distance_to_airport: 'Entfernung zum Flughafen',
    roi: 'Prognose ROI',
    amenities: 'Ausstattung',
    yes: 'Ja',
    no: 'Nein',
    infrastructure: 'Infrastruktur',
    nearby: 'In der Nähe',
    gallery: 'Galerie',
    video: 'Video',

    // bereits hinzugefügt
    total: 'Gesamtanzahl der Einheiten',
    available: 'Verfügbar',
    buildings: 'Gebäude',
    floors_short: 'Etg.',
    cover_alt: 'Titelbild der Wohnanlage',

    // 🔹 neue Schlüssel für die Komponente
    details: {
      developer: 'Bauträger',
      location: 'Standort',
      country: 'Land',
      region: 'Region',
      city: 'Stadt',
      district: 'Stadtteil',
      characteristics: 'Merkmale',
      class: 'Klasse',
      buildings_count: 'Anzahl der Gebäude',
      construction_start: 'Baubeginn',
      sales_start: 'Verkaufsstart',
      construction_end: 'Bauende',
      delivery: 'Übergabe',
      investments_prices: 'Investitionen und Preise',
      total_value_available: 'Gesamtwert der verfügbaren Wohnungen',
      price_from: 'Preis ab',
      price_to: 'Preis bis',
      price_per_sqm: 'Preis pro m²',
      roi: 'Prognose ROI',
      amenities: 'Ausstattung',
      infrastructure: 'Infrastruktur',
      description: 'Beschreibung',
      distances: 'Entfernungen',
      to_sea: 'Zum Meer',
      to_center: 'Zum Zentrum',
      to_airport: 'Zum Flughafen'
    },

    // Beispielschlüssel für Ausstattung
    amenities: {
      pool: 'Schwimmbad',
      parking: 'Parkplatz',
      gym: 'Fitnessstudio',
      security: 'Sicherheit'
      // weitere aus dem Backend ergänzen
    },

    // Beispielschlüssel für Infrastruktur
    infrastructure: {
      school: 'Schule',
      kindergarten: 'Kindergarten',
      supermarket: 'Supermarkt',
      hospital: 'Krankenhaus'
      // weitere aus dem Backend ergänzen
    },

    properties_in_complex: 'Wohnungen in dieser Anlage',
    description: 'Beschreibung'
  },
  residential_class: {
    complex: {
      class: 'Klasse'
    }
  },
  loading: 'Wird geladen...'
}
